module.exports = __webpack_public_path__ + "static/media/guide_Page_12.59a89c0d.png";